export default __webpack_public_path__ + "static/media/Payments.0fbc9db0.png";